import { render, staticRenderFns } from "./Studentportal.vue?vue&type=template&id=ec191e52"
import script from "./Studentportal.vue?vue&type=script&lang=js"
export * from "./Studentportal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports